module.exports = "data:image/svg+xml;base64,PHN2ZyBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iNjQiIGhlaWdodD0iNjQiPjxkZWZzPjxzdHlsZS8+PC9kZWZzPjxwYXRoIGQ9Ik01NjguNiAwaDQ1NC45djQ1NC45SDU2OC42VjB6bTAgNTY4LjZoNDU0Ljl2NDU0LjlINTY4LjZWNTY4LjZ6TTAgNTY4LjZoNDU0Ljl2NDU0LjlIMFY1NjguNnpNMCAwaDQ1NC45djQ1NC45SDBWMHoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/table.svg
// module id = oSYw
// module chunks = 72